export default __webpack_public_path__ + "static/Plots0023-59826c26a3256d3b2d5622065b9dde67.jpg";